module.exports = __webpack_public_path__ + "static/media/MetuoPersonalUse-Bold.c7c7337a.otf";